<template>
	<div>
		<el-form :inline="true" label-width="100px">
			<div v-for="(item, index) in groups" :key="index">
				<span class="index">{{ index + 1 }}</span>
				<el-form-item label="选择工序">
					<el-select v-model="item.id" clearable placeholder="工序名">
						<el-option v-for="option in groupData" :key="option._id.$oid" :label="option.name" :value="option._id.$oid"> </el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<a href="javascript:;" v-show="index > 0" v-on:click="remove(index)">
						<i class="el-icon-delete"></i>
					</a>
				</el-form-item>
			</div>
			<div class="opts">
				<el-button type="info" icon="el-icon-plus" circle @click="add"></el-button>
			</div>
		</el-form>
	</div>
</template>

<script>
	import { processGroupRequest } from '@/network/requests/processGroup'
	export default {
		data() {
			return {
				groupData: [],
			}
		},
		props: {
			groups: {
				type: Array,
			},
		},
		model: {
			prop: 'groups',
			event: 'changeForm',
		},
		methods: {
			changeForm() {
				this.$emit('change', this.form)
			},
			add() {
				this.group.push({
					id: '',
				})
			},
			remove(index) {
				this.group.splice(index, 1)
			},
			handleSelect(item) {
				console.log(item)
			},
		},
		created() {
			/**
			 * 加载所有工序组。
			 */
			processGroupRequest.queryAll().then(res => {
				this.groupData = res
			})

			if (this.processes.length == 0) this.add()
		},
	}
</script>

<style scoped>
	.index {
		padding-top: 10px;
		display: inline-block;
		width: 30px;
		color: #aaa;
	}

	.opts {
		padding-left: 0px;
	}
</style>
